import React from 'react';
import AboutSection from '../Components/Home/AboutSection';
import Footer from '../Components/Home/Footer';
import HeroSection from '../Components/Home/HeroSection';
import InstagramSection from '../Components/Home/InstagramSection';
import ProjectSection from '../Components/Home/ProjectSection';
import Navbar from '../Components/Navbar/Navbar';

const Home = () => {
    return (
        <div>
            <Navbar bgColor={"rgba(255, 255, 255, 0.6)"} textColor={'#000'} />
            <HeroSection />
            <AboutSection />
            <ProjectSection />
            <InstagramSection />
            <Footer />
        </div>
    );
};

export default Home;